export default {
  'LOBBYBANNER' (state) {
    return state.lobbybanner
  },
  'LOBBYBANNERS' (state) {
    return state.lobbybanners
  }
}
